module.exports = __webpack_public_path__ + "assets/img/4-1.32138b32.jpg";